export const dateFormatList = "DD/MM/YYYY";
